import React, { Component } from 'react'
import { string, arrayOf, func, object, shape, oneOfType, number, bool } from 'prop-types'
import DatePicker from 'react-datepicker'
import moment from 'moment'

export class Birthdate extends Component {
  constructor ({ value }) {
    super()
    this.state = {
      errors: [],
      isValid: false,
      value: value ? moment(value, 'DD/MM/YYYY') : ''
    }
  }

  get value () {
    return (this.state.value ? this.state.value.format('DD/MM/YYYY') : '')
  }

  handleChange (_date) {
    var date = moment(_date || 'Invalid date', 'DD/MM/YYYY')

    var errors = []
    var isValid = date.isValid()
    if (!isValid) { errors.push('Une date de naissance valide est requise') }

    var state = { isValid: isValid, errors: errors, value: (isValid ? date : '') }

    this.setState(state, () => {
      if (this.props.onChange) { this.props.onChange(this.value, this.props.name) }
    })
    return state
  }

  handleValidation () {
    return this.handleChange(this.state.value)
  }

  handleOnBlur () {
    this.handleChange(this.state.value)
  }

  componentWillReceiveProps (nextprops) {
    if (this.state.value || nextprops.value) {
      this.setState({ value: nextprops.value ? moment(nextprops.value, 'DD/MM/YYYY') : '' })
    }
  }

  render () {
    let error = this.state.errors != null && this.state.errors.length > 0
    return (<div>
      <div className='clearfix birthdate-input'>
        <label style={(this.props.bold) ? {fontWeight: 500} : {}} className={'form__label' + (error ? ' form__label--error' : '')} htmlFor={this.props.name} >{this.props.label}</label>
        <div className='clearfix form-input-span'>
          <DatePicker
            selected={this.state.value}
            onChange={(_date) => this.handleChange(_date)}
            onBlur={() => this.handleOnBlur()}
            showMonthDropdown
            showYearDropdown
            dropdownMode='select'
            maxDate={moment().subtract(18, 'years')}
            className={this.props.className ? [this.props.className, 'form__input ' + (error ? ' form__input--error' : '')] : ['form__input' + (error ? ' form__input--error' : '')]}
              />
        </div>
      </div>
      {
            error
            ? <p className='form__errormessage' >{this.state.errors[0]}</p>
            : ''
          }
    </div>)
  }
}

Birthdate.propTypes = {
  label: string.isRequired,
  name: string.isRequired,
  type: string.isRequired,
  rules: arrayOf(shape({
    type: string,
    message: string,
    expected: oneOfType([
      string,
      number,
      bool
    ])
  })),
  value: oneOfType([string, object]),
  onChange: func,
  className: string,
  associated: object,
  bold: bool
}

Birthdate.defaultProps = {
  value: ''
}



// WEBPACK FOOTER //
// ./src/components/ui/inputs/Birthdate.js